export default __webpack_public_path__ + "assets/0c0eea99fdeff8e091fc68e7637024dc.svg";